import { isDefined, isFunction, isObject } from './Micro';
import { UserManager } from './UserManager';
import { BoardMacroEngine } from '@UI/Dashboard/BoardMacroEngine';
// ------------------------------------------------------------
export interface YFetchOptions {
    url: string;
    headers?: { [key: string]: any; };
    contentType?: string; // --> body
    body?: any;
    extraOpts?: JQueryAjaxSettings;
    onSuccess?: (data: any) => void;
    onFail?: (statusText: string) => void;
    onUnauthorize?: (loginPath: string) => void;
    onComplete?: () => any;
}
// ------------------------------------------------------------
export class YFetch {
    // --------------------------------------------------------
    public static loginPathHeader = 'Login-Path';
    // --------------------------------------------------------
    public static get(opts: YFetchOptions) {
        return YFetch.request('GET', opts);
    }
    // --------------------------------------------------------
    public static post(opts: YFetchOptions) {
        return YFetch.request('POST', opts);
    }
    // --------------------------------------------------------
    public static async request(method: string, opts: YFetchOptions) {
        let headers = opts.headers ?? {};
        let body = null;

        if (method != 'GET') {
            headers['Content-Type'] = 'application/json';
            if (isObject(opts.body))
                body = JSON.stringify(opts.body);
        }

        if (process.env.GLOW_BUILD)
            headers['Authorization'] = `Bearer ${UserManager.GetInstance()?.getAccessToken()}`;
        else
            headers['Authorization'] = `Bearer ${BoardMacroEngine.GetAccessToken()}`;

        if (isDefined(opts.contentType))
            headers['Content-Type'] = opts.contentType;

        try {
            let rsp = await fetch(opts.url, {
                method: method,
                body: body,
                headers: headers,
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'include'
            });

            let text = await rsp?.text();
            let data = text && JSON.parse(text);

            // ok
            if (rsp.ok) {
                if (isFunction(opts.onSuccess))
                    opts.onSuccess(data);
            } // unauthorize
            else if (rsp.status == 401 || rsp.status == 403) {
                if (isFunction(opts.onUnauthorize)) {
                    let loginPath = rsp.headers?.get(YFetch.loginPathHeader) ?? null;
                    opts.onUnauthorize(loginPath);
                }
            } // fail
            else {
                if (isFunction(opts.onFail))
                    opts.onFail(rsp.statusText);
            }
            if (isFunction(opts.onComplete))
                opts.onComplete();
            return data;
        }
        catch (e) {
            if (isFunction(opts.onFail))
                opts.onFail(e);
            if (isFunction(opts.onComplete))
                opts.onComplete();
        }
    }
    // --------------------------------------------------------
}